export const getCounterText = (name: string, length: number): string => {
  switch (name) {
    case 'title': {
      if (length >= 1 && length <= 60) {
        return `${length}`
      }
      if (length > 60 && length < 80) {
        return `Too long: ${length}`
      }
      if (length > 80) {
        return `Too long: ${length}`
      }
      return `${length}`
    }
    case 'description': {
      if (length >= 1 && length <= 49) {
        return `Too short: ${length}`
      }
      if (length >= 50 && length <= 160) {
        return `${length}`
      }
      if (length > 160) {
        return `Too long: ${length}`
      }
      return '0'
    }
    case 'slug': {
      if (length > 25) {
        return `Too long: ${length}`
      }
      return `${length}`
    }
    default:
      return `${length}`
  }
}
